import { createTheme } from '@mui/material/styles'

import breakpoints from './theme/breakpoints'
import components from './theme/components'
import palette from './theme/palette'
import sizes from './theme/sizes'
import typography from './theme/typography'

const theme = createTheme({
  breakpoints,
  components,
  palette,
  typography,
  shape: { borderRadius: 0 },
  sizes,
})

export default theme
